export default __webpack_public_path__ + "static/media/fo.f028ed58.svg";